import React from "react";
import SketchesShop from "../../components/SketchesShop/SketchesShop";
import "./SketchesPage.css";

function SketchesPage() {
  return (
    <div>
      <SketchesShop />
    </div>
  );
}

export default SketchesPage;
